import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { Observable } from 'rxjs';
import { NgbPopoverConfig } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-artie-says',
  templateUrl: './artie-says.component.html',
  styleUrls: ['./artie-says.component.scss']
})
export class ArtieSaysComponent implements OnInit {

  artieSaysText: string;

  constructor(private firebasedb: AngularFireDatabase, configPopover: NgbPopoverConfig) {
    configPopover.placement = 'left';
   // configPopover.triggers = 'mouseenter:mouseleave';
  }

  ngOnInit(): void {
    this.firebasedb.object('public/Artie Says').valueChanges().subscribe(theText => {
      this.artieSaysText = theText as string;
      return this.artieSaysText;
    });
  }

}
